<template>
	<div class="popup-unlock" v-hammer:tap="close">
		<div class="content">
			<transition name="title" appear>
				<div v-show="visible >= 1" class="title">{{ title }}</div>
			</transition>

			<transition name="element" appear>
				<div v-show="visible >= 2" class="element">

					<transition name="element-name" appear>
						<p v-show="visible >= 3" class="element-name">{{ element[lang].name }}</p>
					</transition>

					<div v-if="popup.unlock.type === 'character'" class="card-wrap">
						<portrait :hero="element" face="front" />
					</div>

					<transition name="element-description" appear>
						<ui-text v-show="visible >= 3" class="element-description" :text="element[lang].description" />
					</transition>

				</div>
			</transition>

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { lang } from '@/js/lang'
import { generate_hero } from '@/js/board'
import Portrait from '@/components/global/portrait'
import UiText from '@/components/ui/ui-text'
import Sounds from '@/js/sounds'

export default {
	name: 'popup-unlock',
	data() {
		return {
			element: null,
			visible: 0
		}
	},
	props: {
		popup: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ]),
		title() {
			if (this.popup.unlock.type === 'character') return lang('new_unlocked_character')
			return ""
		}
	},
	methods: {
		close(e) {
			if (!e.srcEvent.stopped && this.visible >= 3) {
				this.$store.dispatch('add_viewed_unlock', { unlock: this.popup.unlock })
				this.$store.dispatch('check_unlocks')
				this.$emit('close')
			}
		}
	},
	mounted() {
		setTimeout(() => {
			Sounds.play('unlock-character')
			this.visible++
			setTimeout(() => {
				Sounds.play('unlock')
				this.visible++
				setTimeout(() => {
					this.visible++
				}, 500)
			}, 500)
		}, 250)
	},
	created() {
		if (this.popup.unlock && this.popup.unlock.slug) {
			if (this.popup.unlock.type === 'character') this.element = generate_hero({ slug: this.popup.unlock.slug })
		}
	},
	components: { Portrait, UiText }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'


.popup-unlock
	absolute 0
	flex center center
	color #fff
	text-align center
	font-size 4rem
	&.unusable
		.content
			.power-wrap
				>>> .power
					.mana
						display none
	.content
		height 100%
		width 100%
		max-width 600px
		margin 0 auto
		flex center center column
		.title
			position absolute
			left 0
			right 0
			top 64px
			font-size 8rem
			text-align center
			line-height 0.8em
			transition 0.25s easeOutQuart
			&.title-enter
				transform translateY(40px)
				opacity 0
			
		.element
			width 100%
			transition 0.25s easeInQuart
			&.element-enter
				transform scale(2)
				opacity 0
			.element-name
				position absolute
				left 0
				right 0
				bottom calc(100% + 8px)
				font-size 6.4rem
				width 100%
				text-align center
				transition 0.25s easeOutQuart
				&.element-name-enter
					transform translateY(40px)
					opacity 0
			.card-wrap
				margin 80px 0
				width 100%
				flex center center
				transform scale(2)
			.element-description
				position absolute
				left 0
				right 0
				top calc(100% + 8px)
				width 100%
				text-align center
				transition 0.25s easeOutQuart
				&.element-description-enter
					transform translateY(-40px)
					opacity 0
				&:last-child
					margin 0

</style>
